/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Embedding_Error_Connector_PermissionInputs */



/**
* | output |
* | --- |
* | "The connection is not allowed to read this file. Check the permissions at the source and retry." |
*
* @param {Embedding_Error_Connector_PermissionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const embedding_error_connector_permission = /** @type {((inputs?: Embedding_Error_Connector_PermissionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Embedding_Error_Connector_PermissionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Die Verbindung darf diese Datei nicht lesen. Prüfen Sie die Berechtigungen an der Quelle und versuchen Sie es erneut.")
	return /** @type {LocalizedString} */ ("The connection is not allowed to read this file. Check the permissions at the source and retry.")
});